/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.common.AccentColor
*/
export var AccentColor;
(function (AccentColor) {
    AccentColor["SLATE"] = "SLATE";
    AccentColor["RED"] = "RED";
    AccentColor["ORANGE"] = "ORANGE";
    AccentColor["AMBER"] = "AMBER";
    AccentColor["GREEN"] = "GREEN";
    AccentColor["TEAL"] = "TEAL";
    AccentColor["CYAN"] = "CYAN";
    AccentColor["BLUE"] = "BLUE";
    AccentColor["INDIGO"] = "INDIGO";
    AccentColor["PURPLE"] = "PURPLE";
    AccentColor["PINK"] = "PINK";
    AccentColor["ROSE"] = "ROSE";
})(AccentColor || (AccentColor = {}));
//# sourceMappingURL=AccentColor.js.map